import { render, staticRenderFns } from "./ForumEventSessions.vue?vue&type=template&id=0bb596ae&scoped=true"
import script from "./ForumEventSessions.vue?vue&type=script&lang=js"
export * from "./ForumEventSessions.vue?vue&type=script&lang=js"
import style0 from "./ForumEventSessions.vue?vue&type=style&index=0&id=0bb596ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb596ae",
  null
  
)

export default component.exports